import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './transfertCJ.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export function TransfertCJIcon(props: IconProps) {
  return <Icon className={props.className} />;
}
